import { Box, Toolbar } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import SideBar from "./SideBar";

const Layout = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Header />
      <SideBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100%",
          overflow: "auto",
          margin: "1%",
        }}
      >
        <Toolbar />
        <Outlet />
        <Toolbar />
        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;
